import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toolbar-button-text" }

import vue from '../../../adapter-vue';
import { isH5 } from '../../../utils/env';
import Icon from '../../common/Icon.vue';
import { TUITranslateService, TUIChatService, IConversationModel, StoreName, TUIStore } from '../../../@aidesk/uikit-engine';
import { isEnabledMessageReadReceiptGlobal, getTo, debounce } from '../../../utils/utils';
interface IProps {
  title?:string;
  icon?:string | undefined;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'toolbar-button-human-service',
  props: {
    title: { default: '' },
    icon: { default: '' }
  },
  emits: ['closePopover'],
  setup(__props: any, { emit: __emit }) {

const { ref, onMounted, onUnmounted } = vue;
const currentConversation = ref<IConversationModel>();
const props = __props;

const emits = __emit;

onMounted(() => {
  TUIStore.watch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate,
  });
});

onUnmounted(() => {
  TUIStore.unwatch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate,
  });
});

const onCurrentConversationUpdate = (conversation: IConversationModel) => {
  currentConversation.value = conversation;
};

const onClick = debounce(() => {
  if (!currentConversation.value) {
    return;
  }
  TUIChatService.sendTextMessage({
    to: getTo(currentConversation.value),
    conversationType: currentConversation.value.type,
    payload: {
      text: TUITranslateService.t('AIDesk.转人工服务')
    },
    needReadReceipt: isEnabledMessageReadReceiptGlobal(),
  })
  .finally(() => {
    emits('closePopover');
  });
}, 300);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['toolbar-button', _unref(isH5) ? 'toolbar-button-h5' : '']),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onClick) && _unref(onClick)(...args)))
  }, [
    (props.icon)
      ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          class: "toolbar-button-icon",
          file: props.icon,
          width: "14px",
          height: "14px"
        }, null, 8, ["file"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, _toDisplayString(props.title || _unref(TUITranslateService).t('AIDesk.转人工服务')), 1)
  ], 2))
}
}

})